import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=aefc1c30&scoped=true"
var script = {}
import style0 from "./CustomFooter.vue?vue&type=style&index=0&id=aefc1c30&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefc1c30",
  null
  
)

export default component.exports